import React, { useEffect, useState } from 'react';
import nexo from '../../nexoClient';
import { Page, Layout, FormField } from '@nimbus-ds/patterns';
import { Box } from '@nimbus-ds/components';
import { navigateHeader } from '@tiendanube/nexo/helpers';
import axiosInstance from '../../axios';
import { useWindowWidth } from '../../hooks';
import tokens from '@nimbus-ds/tokens/dist/js/tokens';
import { useHistory } from 'react-router-dom';

const LogsPage: React.FC = () => {
  const { push } = useHistory();
  const windowWidth = useWindowWidth();
  const breakpointMd = tokens.breakpoint.md.value.replace('px', '');

  useEffect(() => {
    navigateHeader(nexo, { goTo: '/', text: 'Volver al inicio' });
  }, []);

  const goToSetup = () => push('/setup');

  return (
    <Page maxWidth="1200px">
      <Page.Header title="Registros" />
      <Page.Body>
        <Box></Box>
      </Page.Body>
    </Page>
  );
};

export default LogsPage;
